import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  constructor(private t: TranslateService) {}

  transform(duration: number | undefined): string {
    if (!duration) {
      return '';
    }

    if (duration < 60) {
      return `${duration} ${this.t.instant('minutes')}`;
    }

    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;

    if (minutes) {
      return `${hours} ${
        hours > 1 ? this.t.instant('hours') : this.t.instant('hour')
      } ${minutes} ${this.t.instant('minutes')}`;
    }

    return `${hours} ${
      hours > 1 ? this.t.instant('hours') : this.t.instant('hour')
    }`;
  }
}
